import { z } from "zod";
import {
  cancellationReason,
  identityMethodId,
  paymentErrorCategory,
  paymentStatus,
} from "./ftthOrchestrator";

export const state = z.enum([
  "START",
  "COMPLETED",
  "ORDER_SUMMARY",
  "ORDER_COMMITTED",
  "ORDER_FULFILLMENT",
  "ORDER_PAYMENT",
  "ORDER_PAYMENT_ERROR",
  "ORDER_PENDING_CANCELLATION",
]);

const actionsRel = z.enum(["ORDER_COMMIT", "OFFER_SELECT", "ORDER_CANCEL"]);

export const actions = z.array(
  z.object({
    href: z.string(),
    method: z.string(),
    rel: actionsRel,
  }),
);

const orderSummary = z.object({
  totalOrderPrice: z.number(),
  totalRecurringOrderPrice: z.number(),
  totalOneTimeOrderPrice: z.number(),
  discount: z.number().optional(),
  totalOrderDiscount: z.number().optional(),
  totalRecurringOrderBasePrice: z.number().optional(),
  items: z.array(
    z.object({
      offerId: z.string(),
      offerPrice: z.number(),
      offerPriceType: z.string(),
    }),
  ),
});

export const fsecureOrchestrator = z.object({
  type: z.literal("NJU_FSECURE_ONBOARDING"),
  state,
  actions,
  id: z.string(),
  processId: z.string().optional(),
  userId: z.string(),
  orderId: z.string().optional(),
  isUserVerified: z.boolean().optional(),
  identityMethodId: identityMethodId.optional(),
  paymentErrorCategory: paymentErrorCategory.optional(),
  cancellationReason: cancellationReason.optional(),
  paymentStatus: paymentStatus.optional(),
  orderSummary: orderSummary.optional(),
  offerIds: z.array(z.string()),
  productVariant: z.string().optional(),
});

type IFSecureOrchestratorAPI = z.infer<typeof fsecureOrchestrator>;

export type IFSecureOrchestrator = IFSecureOrchestratorAPI & {
  offerId?: string;
};
